import clsx from 'clsx'
import { Card, Form, Input, RichTextEditor } from 'components/common'

export interface TitleAndDescriptionProps {
  title?: string
  description?: string
  loading?: boolean
  maxTitleLength?: number
  maxDescriptionLength?: number
}

export interface TitleAndDescriptionFormValues {
  title: string
  description?: string
}

export const TitleAndDescription = ({
  title,
  description,
  maxTitleLength,
  maxDescriptionLength,
  loading = false,
}: TitleAndDescriptionProps): JSX.Element => {
  return (
    <>
      <Card shadow loading={loading}>
        <div className={clsx('mb-8')}>
          <Form.Item
            label="タイトル"
            labelCol={{ span: 24 }}
            name={'title'}
            initialValue={title}
            rules={[
              { required: true, message: 'タイトルは必須です。' },
              maxTitleLength > 0 && {
                max: maxTitleLength,
              },
            ]}
          >
            <Input autoComplete="off" />
          </Form.Item>
        </div>

        <div>
          <Form.Item
            label="説明"
            name={'description'}
            initialValue={description}
            rules={[
              maxDescriptionLength > 0 && {
                max: maxDescriptionLength,
              },
            ]}
          >
            <RichTextEditor defaultValue={description} />
          </Form.Item>
        </div>
      </Card>
    </>
  )
}
